export default "__VITE_ASSET__Xb_vVrZ7__"